import { render, staticRenderFns } from "./CellRadio.vue?vue&type=template&id=47490118&scoped=true"
import script from "./CellRadio.vue?vue&type=script&lang=js"
export * from "./CellRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47490118",
  null
  
)

export default component.exports